<template>
  <div>
    <div v-clickoutside="hideReplyBtn" @click="inputFocus" class="my-reply">
      <el-avatar class="header-img" :size="40" :src="myHeader"></el-avatar>
      <div class="reply-info">
        <div
          tabindex="0"
          contenteditable="true"
          id="replyInput"
          spellcheck="false"
          placeholder="输入评论..."
          class="reply-input"
          @focus="showReplyBtn"
          @input="onDivInput($event)"
        ></div>
      </div>
      <div class="reply-btn-box" v-show="btnShow">
        <el-button
          class="reply-btn"
          size="medium"
          @click="sendComment"
          type="primary"
        >
          发表评论
        </el-button>
      </div>
    </div>
    <div
      style="text-align: left"
      v-for="(item, i) in comments"
      :key="i"
      class="author-title reply-father"
    >
      <el-avatar class="header-img" :size="40" :src="item.headImg"></el-avatar>
      <div class="author-info">
        <span class="author-name">{{ item.name }}</span>
        <span class="author-time">{{ item.time }}</span>
      </div>
      <div class="icon-btn">
        <span @click="showReplyInput(i, '0', item.name, item.id)">
          <i class="iconfont el-icon-s-comment"></i>
          {{ item.commentNum }}
        </span>
        <!-- <span  @click="addlikeNumber(i, item.from, item.id)">
        <i class="iconfont el-icon-caret-top"></i>
        {{ item.like }}
        </span> -->
        <span class="xin" @click="countlikeNumber('1', i, item.id)">
          <i class="iconfont el-icon-caret-top" v-if="item.isLike">&#xe607;</i>
          <i class="iconfont el-icon-caret-top" v-else>&#xe68b;</i>
          {{ item.like }}
        </span>
      </div>
      <div class="talk-box">
        <p>
          <span class="reply">{{ item.comment }}</span>
        </p>
      </div>
      <div class="reply-box">
        <div v-for="(reply, j) in item.reply" :key="j" class="author-title">
          <el-avatar
            class="header-img"
            :size="40"
            :src="reply.fromHeadImg"
          ></el-avatar>
          <div class="author-info">
            <span class="author-name">{{ reply.from }}</span>
            <span class="author-time">{{ reply.time }}</span>
          </div>
          <div class="icon-btn">
            <span @click="showReplyInput(i, j, reply.from, reply.id)">
              <i class="iconfont el-icon-s-comment"></i>
              {{ reply.commentNum }}
            </span>
            <span @click="countlikeNumber('2', i, j, reply)">
              <i class="iconfont el-icon-caret-top"></i>
              {{ reply.like }}
            </span>
          </div>
          <div class="talk-box">
            <p>
              <span>回复 {{ reply.to }}:</span>
              <span class="reply">{{ reply.comment }}</span>
            </p>
          </div>
          <div class="reply-box"></div>
        </div>
      </div>
      <div v-show="_inputShow(i)" class="my-reply my-comment-reply">
        <el-avatar class="header-img" :size="40" :src="myHeader"></el-avatar>
        <div class="reply-info">
          <div
            tabindex="0"
            contenteditable="true"
            spellcheck="false"
            placeholder="输入评论..."
            @input="onDivInput($event)"
            class="reply-input reply-comment-input"
          ></div>
        </div>
        <div class="reply-btn-box">
          <el-button
            class="reply-btn"
            size="medium"
            @click="sendCommentReply(i)"
            type="primary"
          >
            发表回复
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
const clickoutside = {
  // 初始化指令
  bind(el, binding, vnode) {
    function documentHandler(e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false;
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(e);
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.vueClickOutside = documentHandler;
    document.addEventListener("click", documentHandler);
  },
  update() {},
  unbind(el, binding) {
    // 解除事件监听
    document.removeEventListener("click", el.vueClickOutside);
    delete el.vueClickOutside;
  },
};
export default {
  name: "ArticleComment",
  data() {
    return {
      btnShow: false,
      index: "0",
      replyComment: "",
      subIndex: "0",
      myName: "石老师",
      myHeader:
        "https://ae01.alicdn.com/kf/Hd60a3f7c06fd47ae85624badd32ce54dv.jpg",
      myId: 19870621,
      to: "",
      toId: -1,
  comments: [
        {
          name: "热心学者1",
          id: 19870621,
          headImg:
            "https://ae01.alicdn.com/kf/H94c78935ffa64e7e977544d19ecebf06L.jpg",
          comment:
            "石老师，我最近在读布拉格语言学流派的一本书，里面有句话，“音系学是语言学的组成部分，而语音学只是语言学的一门辅助学科，它事实上是一门自然科学”，为什么语音学是自然科学？您可以帮忙解释下吗？",
          time: "2022年9月6日 18:43",
          commentNum: 2,
          like: 15,
          isLike: false,
          likeListId: [], //存放已点赞用户的id
          inputShow: false,
          reply: [
            {
              from: "石老师",
              fromId: 19891221,
              fromHeadImg:
                "https://ae01.alicdn.com/kf/Hd60a3f7c06fd47ae85624badd32ce54dv.jpg",
              to: "Lana Del Rey",
              toId: 19870621,
              comment:
                "我本来是不同意布拉格学派的这种观点。他们所讲的“语音学是自然科学”，应该指的是语音学的实验方法和研究对象的物理性质。实际上，语音学和音系学是不能分开的。因为人类的语音都是成系统的，所以只要研究语音，不可能脱离语音的系统。游离于系统之外的语音是不存在的。人类语言就是有声语言。语音不仅是自成系统，而且还负载着语言各个子系统的内容。如果语言是信息的载体，语音就是语言的载体。语音学是语言学的一门基础学科。",
              time: "2022年9月16日 18:43",
              commentNum: 1,
              like: 15,
              isLike: false,
              likeListId: [],
              inputShow: false,
            },
          ],
        },
        {
          name: "热心学者2",
          id: 19891221,
          headImg:
            "https://ae01.alicdn.com/kf/H94c78935ffa64e7e977544d19ecebf06L.jpg",
          comment:
            "如何把两个声调看成是一个？如果根据T值来算，两个声调各个点之间的值相差多少，可以看成一个调？",
          time: "2022年9月16日 18:43",
          commentNum: 1,
          like: 5,
          likeListId: [],
          inputShow: false,
          reply: [
            {
              from: "石老师",
              fromId: 19870621,
              fromHeadImg:
                "https://ae01.alicdn.com/kf/Hd60a3f7c06fd47ae85624badd32ce54dv.jpg",
              to: "热心学者2",
              toId: 19891221,
              comment:
                "你提的问题很有意义。两个声调接近到什么程度，可以判定为已经合并为同一个声调。当然问题还可以反过来考虑：一个声调的两个变体相差到什么程度，可以判定为已经分化为两个声调。可以分为两个方面来考虑。一个是调层，一个是调型。在调型相同的情况下，例如，同是平调，或同是降调，二者高度相差多少会听为不同的声调。两个调型不同的声调，如一个平调一个降调，或一个升调一个降调，二者起点或终点相差到什么程度会听为不同的声调。我在“试论普通话声调的本调”（2020）文章中已经涉及这个问题。只是没有专门讨论。声调的分合问题不能只从声学实验中解决，而是要用听感测试来解决。而且具体的情况会比较复杂。首先是作为测试对象的语言中要实际存在这样两个声调的调位对立，才能测试二者的听感边界。而且这听感边界还会受到不同因素的影响而发生动态变化。如：调阶对立跟调型对立表现不一样，在单音和连音时不一样，连音时在前字和在后字又不一样，而且不论连音在前字和在后字，邻接不同的声调时也会不一样，等等。",
              time: "2022年9月16日 18:43",
              commentNum: 25,
              like: 5,
              isLike: false,
              likeListId: [],
              inputShow: false,
            },
          ],
        },
        {
          name: "热心学者3",
          id: 20190830,
          headImg:
            "https://ae01.alicdn.com/kf/Hdd856ae4c81545d2b51fa0c209f7aa28Z.jpg",
          comment: "蟹堡秘方是什么？",
          time: "2022年9月5日 18:43",
          commentNum: 0,
          like: 5,
          isLike: false,
          likeListId: [],
          inputShow: false,
          reply: [
            {
              from: "石老师",
              fromId: 19870621,
              fromHeadImg:
                "https://ae01.alicdn.com/kf/Hd60a3f7c06fd47ae85624badd32ce54dv.jpg",
              to: "热心学者4",
              toId: 19891221,
              comment:
                "蟹煲的配方是一次意外，蟹老板无意中用一些配方调成，现在只知道有糖糊屑屑，面粉，姜黄和海盐，但最终蟹堡肉饼是怎么做出来的，一直没有说明。",
              time: "2022年9月5日 18:43",
              commentNum: 25,
              like: 5,
              isLike: false,
              likeListId: [],
              inputShow: false,
            },
          ],
        },
        {
          name: "热心学者4",
          id: 20190830,
          headImg:
            "https://ae01.alicdn.com/kf/Hdd856ae4c81545d2b51fa0c209f7aa28Z.jpg",
          comment: "海底为什么可以生火",
          time: "2022年9月5日 18:43",
          commentNum: 0,
          like: 5,
          isLike: false,
          likeListId: [],
          inputShow: false,
          reply: [
            {
              from: "石老师",
              fromId: 19870621,
              fromHeadImg:
                "https://ae01.alicdn.com/kf/Hd60a3f7c06fd47ae85624badd32ce54dv.jpg",
              to: "热心学者4",
              toId: 19891221,
              comment:
                "我们认为在海底里面一定是不能够生火的，但是《海绵宝宝》中就出现了在海底好事呢或的这个画面，所以肯定有很多的小伙伴就会吐槽海地生火的问题，如果真的去较真的话就真的输了。但是毕竟是一部动画吗，没有必要去纠结这些，海底生火也是让在冰冷的海水中的场景更加的形象，而这个经典的穿帮镜头，杠精是很难理解的。在水里面生火，在现实世界中是不可能存在的，估计这个镜头专门为海绵宝宝照他快乐的小伙伴精心设计的吧。",
              time: "2022年9月5日 18:43",
              commentNum: 25,
              like: 5,
              isLike: false,
              likeListId: [],
              inputShow: false,
            },
          ],
        },
        {
          name: "热心学者5",
          id: 20190830,
          headImg:
            "https://ae01.alicdn.com/kf/Hdd856ae4c81545d2b51fa0c209f7aa28Z.jpg",
          comment: "比奇堡居民数量之谜",
          time: "2022年9月5日 18:43",
          commentNum: 0,
          like: 5,
          isLike: false,
          likeListId: [],
          inputShow: false,
          reply: [
            {
              from: "石老师",
              fromId: 19870621,
              fromHeadImg:
                "https://ae01.alicdn.com/kf/Hd60a3f7c06fd47ae85624badd32ce54dv.jpg",
              to: "热心学者5",
              toId: 19891221,
              comment:
                "比奇堡居民的数量一直都是一个迷，有的时候很多，有的时候却很少。或许是比奇堡居民的流动量非常大，才看起来时多时少。",
              time: "2022年9月5日 18:43",
              commentNum: 25,
              like: 5,
              isLike: false,
              likeListId: [],
              inputShow: false,
            },
          ],
        },
      ],
    };
  },
  directives: { clickoutside },
  methods: {
    inputFocus() {
      var replyInput = document.getElementById("replyInput");
      replyInput.style.padding = "8px 8px";
      replyInput.style.border = "2px solid blue";
      replyInput.focus();
    },
    showReplyBtn() {
      this.btnShow = true;
    },
    hideReplyBtn() {
      this.btnShow = false;
      replyInput.style.padding = "10px";
      replyInput.style.border = "none";
    },
    showReplyInput(i, j, name, id) {
      this.comments[this.index].inputShow = false;
      this.index = i;
      this.comments[i].inputShow = true;
      this.to = name;
      this.toId = id;
      this.subIndex = j == "0" ? "0" : j;
    },
    addlikeNumber(i, id) {
      let list = this.comments[i].likeListId;
      // console.log(i, name, id)
      if (list.length === 0) {
        //在已经点赞的列表中未找到userId
        this.comments[i].isLike = true;
        this.comments[i].like += 1;
        this.comments[i].likeListId.push(id);
        console.log(
          "点赞+1",
          this.comments[i].isLike,
          this.comments[i].like,
          this.comments[i].likeListId
        );
      } else {
        const index = list.indexOf(this.myId);
        this.comments[i].isLike = false;
        this.comments[i].like -= 1;
        this.comments[i].likeListId.splice(index, 1);
        console.log(
          "点赞-1",
          this.comments[i].isLike,
          this.comments[i].likeListId
        );
      }
    },
    countlikeNumber(type, i, j, id) {
      const text = type === "1" ? this.comments[i] : this.comments[i].reply[j];
      let list = text.likeListId;
      if (list.length === 0) {
        //在已经点赞的列表中未找到userId
        text.isLike = true;
        text.like += 1;
        text.likeListId.push(id);
        console.log("点赞+1", text.isLike, text.like, text.likeListId);
      } else {
        const index = list.indexOf(this.myId);
        text.isLike = false;
        text.like -= 1;
        text.likeListId.splice(index, 1);
        console.log("点赞-1", text.isLike, text.likeListId);
      }
    },
    _inputShow(i) {
      return this.comments[i].inputShow;
    },
    sendComment() {
      if (!this.replyComment) {
        this.$message({
          showClose: true,
          type: "warning",
          message: "评论不能为空",
        });
      } else {
        let a = {};
        let input = document.getElementById("replyInput");
        let timeNow = new Date().getTime();
        let time = this.dateStr(timeNow);
        a.name = this.myName;
        a.comment = this.replyComment;
        a.headImg = this.myHeader;
        a.time = time;
        a.commentNum = 0;
        a.like = 0;
        a.id = this.myId;
        (a.reply = []),
          (a.isLike = false),
          (a.likeListId = []),
          this.comments.push(a);
        this.replyComment = "";
        input.innerHTML = "";
      }
    },
    sendCommentReply(i) {
      if (!this.replyComment) {
        this.$message({
          showClose: true,
          type: "warning",
          message: "回复不能为空",
        });
      } else {
        let a = {};
        let timeNow = new Date().getTime();
        let time = this.dateStr(timeNow);
        a.from = this.myName;
        a.to = this.to;
        a.fromHeadImg = this.myHeader;
        a.comment = this.replyComment;
        a.time = time;
        a.commentNum = 0;
        a.like = 0;
        a.isLike = false;
        a.likeListId = [];
        console.log(
          " this.comments"+[i]+".reply+++++++++++",
          this.comments[i].reply,
          this.subIndex
        );
        if (this.subIndex === "0") {
          this.comments[i].commentNum += 1;
        } else {
          this.comments[i].reply[this.subIndex].commentNum += 1;
        }
        this.comments[i].reply.push(a);
        this.replyComment = "";
        document.getElementsByClassName("reply-comment-input")[i].innerHTML =
          "";
      }
    },
    onDivInput: function (e) {
      this.replyComment = e.target.innerHTML;
    },
    dateStr(date) {
      //获取js 时间戳
      var time = new Date().getTime();
      //去掉 js 时间戳后三位，与php 时间戳保持一致
      time = parseInt((time - date) / 1000);
      //存储转换值
      var s;
      if (time < 60 * 10) {
        //十分钟内
        return "刚刚";
      } else if (time < 60 * 60 && time >= 60 * 10) {
        //超过十分钟少于1小时
        s = Math.floor(time / 60);
        return s + "分钟前";
      } else if (time < 60 * 60 * 24 && time >= 60 * 60) {
        //超过1小时少于24小时
        s = Math.floor(time / 60 / 60);
        return s + "小时前";
      } else if (time < 60 * 60 * 24 * 30 && time >= 60 * 60 * 24) {
        //超过1天少于30天内
        s = Math.floor(time / 60 / 60 / 24);
        return s + "天前";
      } else {
        //超过30天ddd
        var date = new Date(parseInt(date));
        return (
          date.getFullYear() +
          "/" +
          (date.getMonth() + 1) +
          "/" +
          date.getDate()
        );
      }
    },
  },
};
</script>



<style lang="scss" scoped>
.my-reply {
  padding: 10px;
  background-color: #fafbfc;
  .header-img {
    display: inline-block;
    vertical-align: top;
  }
  .reply-info {
    display: inline-block;
    margin-left: 5px;
    width: 90%;
    //根据屏幕宽度自适应

    .reply-input {
      min-height: 20px;
      line-height: 22px;
      padding: 10px 10px;
      color: #ccc;
      background-color: #fff;
      border-radius: 5px;
      // &:empty::before{
      //   content attr(placeholder);
      // }
      &:empty:before {
        content: attr(placeholder);
      }
      &:focus:before {
        content: none;
      }
      &:focus {
        padding: 8px 8px;
        border: 2px solid blue;
        box-shadow: none;
        outline: none;
      }
    }
  }
  .reply-btn-box {
    height: 25px;
    // margin: 10px 0;
    display: inline-block;
    .reply-btn {
      position: relative;
      float: right;
      margin-left: 15px;
      // margin-right: 15px;
    }
  }
}
.my-comment-reply {
  margin-left: 50px;
  .reply-input {
    width: flex;
  }
}
.author-title:not(:last-child) {
  border-bottom: 1px solid rgba(74, 136, 199, 0.3);
}
.reply-father {
  padding: 10px;
  .header-img {
    display: inline-block;
    vertical-align: top;
  }
  .author-info {
    display: inline-block;
    margin-left: 5px;
    width: 60%;
    height: 40px;
    line-height: 20px;
    span {
      display: block;
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .author-name {
      color: #000;
      font-size: 18px;
      font-weight: bold;
    }
    .author-time {
      font-size: 14px;
    }
  }
  .icon-btn {
    width: 30%;
    padding: 0 !important ;
    float: right;

    span {
      cursor: pointer;
    }
    .iconfont {
      margin: 0 5px;
    }
  }
  .talk-box {
    margin: 0 50px;
    p {
      margin: 0;
    }
    .reply {
      font-size: 16px;
      color: #000;
    }
  }
  .reply-box {
    margin: 10px 0 0 50px;
    background-color: #efefef;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/test.vue